<div class="installation-page">
    <mat-tab-group class="stepper" [(selectedIndex)]="selectedTabIndex">
        <mat-tab label="RTLS Studio 3.2.0 and newer">
            @if (selectedTabIndex === 0) {
                <div>
                    <mat-vertical-stepper>
                        <mat-step>
                            <ng-template matStepLabel>Establishing Connection</ng-template>
                            <p>
                                If you have established a connection with myRTLS in <span class="code">Integrations</span> tab of RTLS Studio, the
                                Device Care configuration will be downloaded automatically.
                            </p>
                            <div class="form-buttons">
                                <button mat-button color="primary" matStepperNext>Next</button>
                            </div>
                        </mat-step>
                        @if (metricsStatus$ | async; as metricsStatus) {
                            <mat-step>
                                <ng-template matStepLabel>Data Verification</ng-template>
                                <p>Once the data is loaded you will be able to activate the Device Care by pressing the Finish button.</p>
                                <br />
                                <div class="data-tests">
                                    <div class="data-test">
                                        System Data:
                                        @if (!metricsStatus.system) {
                                            <mat-icon class="pending-icon" fontSet="material-icons-outlined">loop</mat-icon>
                                        }
                                        @if (metricsStatus.system) {
                                            <mat-icon class="text-success ml-3" fontSet="material-icons-outlined">done</mat-icon>
                                        }
                                    </div>
                                    <div class="data-test">
                                        RTLS Studio Data:
                                        @if (!metricsStatus.studio) {
                                            <mat-icon class="pending-icon" fontSet="material-icons-outlined">loop</mat-icon>
                                        }
                                        @if (metricsStatus.studio) {
                                            <mat-icon class="text-success ml-3" fontSet="material-icons-outlined">done</mat-icon>
                                        }
                                    </div>
                                </div>
                                <br />
                                <p>
                                    If you've finished installing Device Care Data Probe and the data are still pending after a few minutes, please
                                    visit the
                                    <a target="_blank" href="https://docs.sewio.net/docs/device-care-troubleshooting-54068205.html"
                                        >Troubleshooting</a
                                    >
                                    section or contact us.
                                </p>
                                <div class="form-buttons">
                                    <button mat-button matStepperPrevious>Back</button>
                                    <button
                                        mat-button
                                        color="primary"
                                        matStepperNext
                                        [disabled]="!metricsStatus.system || !metricsStatus.studio"
                                        (click)="finish()"
                                    >
                                        Finish
                                    </button>
                                </div>
                            </mat-step>
                        }
                    </mat-vertical-stepper>
                </div>
            }
        </mat-tab>
    </mat-tab-group>
</div>
